/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DishDto } from '../models';
// @ts-ignore
import type { DishIdDto } from '../models';
// @ts-ignore
import type { DishPropertiesDto } from '../models';
// @ts-ignore
import type { DishSearchQueryDto } from '../models';
// @ts-ignore
import type { DishesSearchResponseDto } from '../models';
// @ts-ignore
import type { UpdateDishRequestDto } from '../models';
/**
 * RestDishApi - axios parameter creator
 */
export const RestDishApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add dish
         * @param {DishPropertiesDto} dishPropertiesDto Add dish request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDish: async (dishPropertiesDto: DishPropertiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dishPropertiesDto' is not null or undefined
            assertParamExists('addDish', 'dishPropertiesDto', dishPropertiesDto)
            const localVarPath = `/api/dishes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dishPropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get dish
         * @param {number} dishId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDish: async (dishId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dishId' is not null or undefined
            assertParamExists('getDish', 'dishId', dishId)
            const localVarPath = `/api/dishes/{dishId}`
                .replace('{dishId}', encodeURIComponent(String(dishId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for dishes
         * @param {number} page 
         * @param {number} pageSize 
         * @param {DishSearchQueryDto} dishSearchQueryDto Dish search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDishes: async (page: number, pageSize: number, dishSearchQueryDto: DishSearchQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchDishes', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchDishes', 'pageSize', pageSize)
            // verify required parameter 'dishSearchQueryDto' is not null or undefined
            assertParamExists('searchDishes', 'dishSearchQueryDto', dishSearchQueryDto)
            const localVarPath = `/api/dishes/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dishSearchQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update dish
         * @param {number} dishId 
         * @param {UpdateDishRequestDto} updateDishRequestDto Update dish request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDish: async (dishId: number, updateDishRequestDto: UpdateDishRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dishId' is not null or undefined
            assertParamExists('updateDish', 'dishId', dishId)
            // verify required parameter 'updateDishRequestDto' is not null or undefined
            assertParamExists('updateDish', 'updateDishRequestDto', updateDishRequestDto)
            const localVarPath = `/api/dishes/{dishId}`
                .replace('{dishId}', encodeURIComponent(String(dishId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDishRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestDishApi - functional programming interface
 */
export const RestDishApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestDishApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add dish
         * @param {DishPropertiesDto} dishPropertiesDto Add dish request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDish(dishPropertiesDto: DishPropertiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DishIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDish(dishPropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDishApi.addDish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get dish
         * @param {number} dishId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDish(dishId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DishDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDish(dishId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDishApi.getDish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search for dishes
         * @param {number} page 
         * @param {number} pageSize 
         * @param {DishSearchQueryDto} dishSearchQueryDto Dish search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDishes(page: number, pageSize: number, dishSearchQueryDto: DishSearchQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DishesSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDishes(page, pageSize, dishSearchQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDishApi.searchDishes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update dish
         * @param {number} dishId 
         * @param {UpdateDishRequestDto} updateDishRequestDto Update dish request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDish(dishId: number, updateDishRequestDto: UpdateDishRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDish(dishId, updateDishRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDishApi.updateDish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestDishApi - factory interface
 */
export const RestDishApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestDishApiFp(configuration)
    return {
        /**
         * 
         * @summary Add dish
         * @param {DishPropertiesDto} dishPropertiesDto Add dish request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDish(dishPropertiesDto: DishPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<DishIdDto> {
            return localVarFp.addDish(dishPropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get dish
         * @param {number} dishId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDish(dishId: number, options?: RawAxiosRequestConfig): AxiosPromise<DishDto> {
            return localVarFp.getDish(dishId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for dishes
         * @param {number} page 
         * @param {number} pageSize 
         * @param {DishSearchQueryDto} dishSearchQueryDto Dish search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDishes(page: number, pageSize: number, dishSearchQueryDto: DishSearchQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<DishesSearchResponseDto> {
            return localVarFp.searchDishes(page, pageSize, dishSearchQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update dish
         * @param {number} dishId 
         * @param {UpdateDishRequestDto} updateDishRequestDto Update dish request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDish(dishId: number, updateDishRequestDto: UpdateDishRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDish(dishId, updateDishRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestDishApi - interface
 */
export interface RestDishApiInterface {
    /**
     * 
     * @summary Add dish
     * @param {DishPropertiesDto} dishPropertiesDto Add dish request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addDish(dishPropertiesDto: DishPropertiesDto, options?: RawAxiosRequestConfig): AxiosPromise<DishIdDto>;

    /**
     * 
     * @summary Get dish
     * @param {number} dishId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDish(dishId: number, options?: RawAxiosRequestConfig): AxiosPromise<DishDto>;

    /**
     * 
     * @summary Search for dishes
     * @param {number} page 
     * @param {number} pageSize 
     * @param {DishSearchQueryDto} dishSearchQueryDto Dish search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchDishes(page: number, pageSize: number, dishSearchQueryDto: DishSearchQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<DishesSearchResponseDto>;

    /**
     * 
     * @summary Update dish
     * @param {number} dishId 
     * @param {UpdateDishRequestDto} updateDishRequestDto Update dish request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDish(dishId: number, updateDishRequestDto: UpdateDishRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestDishApi - object-oriented interface
 */
export class RestDishApi extends BaseAPI implements RestDishApiInterface {
    /**
     * 
     * @summary Add dish
     * @param {DishPropertiesDto} dishPropertiesDto Add dish request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addDish(dishPropertiesDto: DishPropertiesDto, options?: RawAxiosRequestConfig) {
        return RestDishApiFp(this.configuration).addDish(dishPropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get dish
     * @param {number} dishId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDish(dishId: number, options?: RawAxiosRequestConfig) {
        return RestDishApiFp(this.configuration).getDish(dishId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for dishes
     * @param {number} page 
     * @param {number} pageSize 
     * @param {DishSearchQueryDto} dishSearchQueryDto Dish search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchDishes(page: number, pageSize: number, dishSearchQueryDto: DishSearchQueryDto, options?: RawAxiosRequestConfig) {
        return RestDishApiFp(this.configuration).searchDishes(page, pageSize, dishSearchQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update dish
     * @param {number} dishId 
     * @param {UpdateDishRequestDto} updateDishRequestDto Update dish request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDish(dishId: number, updateDishRequestDto: UpdateDishRequestDto, options?: RawAxiosRequestConfig) {
        return RestDishApiFp(this.configuration).updateDish(dishId, updateDishRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

